var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmergencyHomeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3375_8648",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3375_8648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3168 8.76655H8.68346V4.76655H7.3168V8.76655ZM8.00013 10.9666C8.19324 10.9666 8.35541 10.9009 8.48663 10.7697C8.61785 10.6384 8.68346 10.4789 8.68346 10.2914C8.68346 10.1038 8.61785 9.94166 8.48663 9.80488C8.35541 9.66822 8.19324 9.59988 8.00013 9.59988C7.80713 9.59988 7.64496 9.66822 7.51363 9.80488C7.38241 9.94166 7.3168 10.1038 7.3168 10.2914C7.3168 10.4789 7.38241 10.6384 7.51363 10.7697C7.64496 10.9009 7.80713 10.9666 8.00013 10.9666ZM8.00013 15.7832L0.216797 7.99989L8.00013 0.216553L15.7835 7.99989L8.00013 15.7832Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyHomeWhite);
export default __webpack_public_path__ + "static/media/emergency_home_white.2930abdda7c0a5476295f111d070d506.svg";
export { ForwardRef as ReactComponent };